<template>
	<main
		class="retry-ver-main d-flex flex-column align-items-center retry-gap-4"
	>
		<div class="retry-blue-txt position-relative w-100">
			Retry Verification
			<img
				class="retry-cross rotate-on-hover pointer"
				src="../../assets/newdesign/dashboard/blueCross.svg"
				alt=""
				@click="$emit('close-modal')"
			/>
		</div>
		<img
			src="../../assets/newdesign/BecomePanelist/reverify-linkedin.svg"
			alt=""
		/>
		<div
			class="text-blue fam-mont retry-blue-txt-2 text-center w-100 px-4 retry-px"
		>
			Please verify your LinkedIn profile again
		</div>
		<div class="text-darkgrey retry-yellow-box">
			Your LinkedIn profile verification was unsuccessful. Please reverify your
			profile to ensure accurate details and compliance with our verification
			requirements.
		</div>
		<div
			class="verify-linkedin verify-mt-4 w-100 position-relative"
			:class="{ 'verify-red-border': isInvalid }"
		>
			<div class="verify-linkedin-img">
				<img src="../../assets/newdesign/BecomePanelist/linkedin.svg" alt="" />
			</div>

			<div class="w-90">
				<b-form-input
					placeholder="https://www.linkedin.com/"
					v-model="linkedInUrl"
				></b-form-input>
			</div>
			<div
				v-if="isInvalid"
				class="d-flex align-items-center fam-lato fw-R fs-12 text-red gap-2 link-alert-pos"
			>
				<img
					src="../../assets/newdesign/BecomePanelist/linkedinAlert.svg"
					alt=""
				/>
				Link does not exist/invalid.
			</div>
		</div>
		<b-button class="candash-addBtn mt-3 retry-w-50" @click="goToExpertise()"
			>Proceed</b-button
		>
	</main>
</template>

<script>
import { postLinkedinUrl } from "@/utils/apiFunctions";
export default {
	data() {
		return {
			linkedInUrl: null,
			linkedinRegex:
				/^(https?:\/\/)?(www\.)?linkedin\.com\/(in\/[a-zA-Z0-9\-]+|pub\/[a-zA-Z0-9\-]+\/[0-9]+\/[0-9]+\/[0-9]+)\/?$/,
			isInvalid: false,
		};
	},
	methods: {
		async goToExpertise() {
			try {
				this.isInvalid = !this.linkedinRegex.test(this.linkedInUrl);
				if (!this.isInvalid) {
					let payload = {
						link: this.linkedInUrl,
					};
					const res = await postLinkedinUrl(payload);
					if (res.status == 200) {
						this.$emit("re-verified", { reverified: true });
						this.$emit("close-modal");
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
	},
};
</script>

<style>
.retry-blue-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 20px;
	font-weight: 600;
	color: #20639b;
	display: flex;
	justify-content: center;
}
.retry-blue-txt-2 {
	font-size: 24px;
	font-weight: 700;
}
.retry-yellow-box {
	background-color: #fff0c9;
	border-radius: 6px;
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 500;
	padding: 5px 10px;
	text-align: center;
}
.retry-cross {
	position: absolute;
	right: 0px;
	top: 8px;
}
.retry-w-50 {
	width: 50%;
}
.retry-gap-4 {
	gap: 1.5rem;
}
@media only screen and (max-width: 1028px) {
	.retry-blue-txt {
		font-size: 16px;
		color: #000000;
		padding-top: 8px;
	}
	.retry-blue-txt-2 {
		font-size: 16px;
	}
	.retry-yellow-box {
		font-size: 14px;
	}
	.retry-w-50 {
		width: 100%;
	}
	.retry-px {
		padding-inline: 0 !important;
	}

	.retry-cross {
		top: 12px;
	}
	.retry-gap-4 {
		gap: 1.2rem;
	}
}
.verify-red-border .verify-linkedin-img {
	border: 2px solid #eb0002;
	border-right: none;
}
.verify-red-border .form-control {
	border-top: 2px solid #eb0002 !important;
	border-bottom: 2px solid #eb0002 !important;
	border-right: 2px solid #eb0002 !important;
	border-left: none;
}
.link-alert-pos {
	position: absolute;
	top: 45px;
}
</style>
